import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadListLayoutComponent } from './components/download-list-layout/download-list-layout.component';
import { LayoutDownloadPortalComponent } from './components/layout-download-portal/layout-download-portal.component';
import { DownloadDetail, TargetTab } from './model/download-portal-uris';
import { BaseSoftwareDetailsComponent } from './pages/base-software-details/base-software-details.component';
import { MainReleaseDetailsComponent } from './pages/main-release-details/main-release-details.component';
import { PackagesComponent } from './pages/packages/packages.component';
import { ProductDetailsComponent } from './pages/product-details/product-details.component';
import { ProductsComponent } from './pages/products/products.component';
import { ServiceReleaseDetailsComponent } from './pages/service-release-details/service-release-details.component';
import { SmeComponent } from './pages/sme/sme.component';
import { DownloadDetailsLayoutComponent } from './components/download-details-layout/download-details-layout.component';

export const appRoutes: Routes = [
  {
    path: '',
    title: 'Downloads',
    component: LayoutDownloadPortalComponent,
    children: [
      {
        path: '',
        redirectTo: 'lists/packages',
        pathMatch: 'full',
      },
      {
        path: 'lists',
        component: DownloadListLayoutComponent,
        children: [
          {
            path: 'packages',
            title: 'Basis-Software',
            component: PackagesComponent,
            data: {
              uriId: TargetTab.BASE,
            },
          },
          {
            path: 'products',
            title: 'Zusatz-Software',
            component: ProductsComponent,
            data: {
              uriId: TargetTab.ADDITIONAL,
            },
          },
          {
            path: 'sme',
            title: 'Mittelstand',
            component: SmeComponent,
            data: {
              uriId: TargetTab.SME,
            },
          },
        ],
      },
      {
        path: '',
        component: DownloadDetailsLayoutComponent,
        children: [
          {
            path: 'products/:id',
            title: 'Download Detail',
            component: ProductDetailsComponent,
            data: {
              uriId: DownloadDetail.ADDITIONAL_SOFTWARE_DETAIL,
            },
          },
          {
            path: 'packages/:id',
            title: 'Download Detail',
            component: BaseSoftwareDetailsComponent,
            data: {
              uriId: DownloadDetail.BASE_SOFTWARE_DETAIL,
            },
          },
          {
            path: 'main-releases/:id',
            title: 'Download Detail',
            component: MainReleaseDetailsComponent,
            data: {
              uriId: DownloadDetail.MAIN_RELEASE_DETAIL,
            },
          },
          {
            path: 'service-releases/:id',
            title: 'Download Detail',
            component: ServiceReleaseDetailsComponent,
            data: {
              uriId: DownloadDetail.SERVICE_RELEASE_DETAIL,
            },
          },
        ]
      },
      {
        path: '**',
        redirectTo: 'lists/packages',
        pathMatch: 'full',
      },
    ],
  },
];

